import { WBBox, WBButton, WBFlex } from '@admiin-com/ds-web';
import { styled } from '@mui/material';
import React, { forwardRef } from 'react';
import DragDropField from './DragDropField';
import SignatureDropArea from './SignatureDropArea';
import { useTranslation } from 'react-i18next';
import { SignatureDrawer } from './SignatureDrawer';
import { BottomDrawer } from './BottomDrawer';
import { SigningButton } from './SigningButton';
import { ESignatureSigningProps } from './types';
import { DropContext } from './ESignature';

export const ESignatureMobile = forwardRef(
  (
    {
      documentUrl,
      onPdfLoad,
      annotations,
      userId,
      droppedSignature,
      onDropped,
      handleDraft,
      handleNext,
      onSkip,
      onAnnotationUpdated,
      disableNext,
      onBack,
      skipLabel,
    }: ESignatureSigningProps,
    instanceRef: any
  ) => {
    const { t } = useTranslation();
    const [showSignatureDrawer, setShowSignatureDrawer] =
      React.useState<boolean>(false);
    const handleDrop = (e: any, clickEvent: any) => {
      instanceRef?.current?.handleDrop(e, clickEvent);
      setShowSignatureDrawer(false);
    };

    const [loading, setLoading] = React.useState(false);
    const onNext = async () => {
      try {
        setLoading(true);
        if (handleNext) await handleNext();
      } finally {
        setLoading(false);
      }
    };
    return (
      <>
        <Container>
          <RowContainer>
            <PdfContainer>
              <SignatureDropArea
                documentUrl={documentUrl}
                ref={instanceRef}
                userId={userId}
                annotations={annotations}
                onPdfLoad={onPdfLoad}
                onDrop={onDropped}
                onAnnotationUpdated={onAnnotationUpdated}
              />
            </PdfContainer>
          </RowContainer>
        </Container>
        <DropContext.Provider
          value={{
            handleDrop,
          }}
        >
          <BottomDrawer>
            <WBFlex
              flexDirection={['column']}
              p={1}
              sx={{ bgcolor: 'background.paper' }}
            >
              <WBFlex padding={2}>
                <DragDropField
                  type="SIGNATURE"
                  isMobile
                  onClick={() => setShowSignatureDrawer(true)}
                />
                <DragDropField type="DATE" isMobile signer={droppedSignature} />
                <DragDropField type="NAME" isMobile signer={droppedSignature} />
                <DragDropField type="TEXT" isMobile signer={droppedSignature} />
                <DragDropField
                  type="INITIAL"
                  isMobile
                  signer={droppedSignature}
                />
              </WBFlex>
              <SigningButton
                onNext={onNext}
                loading={loading}
                onSkip={onSkip}
                disableNext={disableNext}
                onBack={onBack}
                skipLabel={skipLabel}
              />
            </WBFlex>
          </BottomDrawer>

          <SignatureDrawer
            open={showSignatureDrawer}
            onClose={() => setShowSignatureDrawer(false)}
          />
        </DropContext.Provider>
      </>
    );
  }
);
const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);

const Container = styled(WBFlex)(({ theme }) => ({
  flexDirection: 'column',
  flex: 1,
  height: '100%',
  paddingBottom: theme.spacing(isSafari ? 24 : 24),
}));
const RowContainer = styled(WBFlex)(({ theme }) => ({
  gap: theme.spacing(2),
  flexDirection: 'column',
  flex: 1,
}));

const PdfContainer = styled(WBBox)(({ theme }) => ({
  flex: 1,
}));

export default ESignatureMobile;
